import { Pressable } from "react-native";
import { View, Text, Button } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { useCallback, useState } from "react";
import { Icon } from "@src/components/Icon";
import { DialogModal } from "@src/components/DialogModal";
import { useOpenGate } from "@visioni/a3s-gate-control/app";
import { showErrorToast } from "@src/utils/toast";

interface GateControlCardProps {
  siteId: string;
  cameraKey: string;
}

export function GateControlCard({ siteId, cameraKey }: GateControlCardProps) {
  const { theme } = useUnistyles();
  const openGateMutation = useOpenGate();
  const [modalVisible, setModalVisible] = useState(false);

  const handlePress = useCallback(() => {
    setModalVisible(true);
  }, []);

  const handleConfirm = useCallback(() => {
    setModalVisible(false);
    openGateMutation.mutate(
      { siteId, cameraKey },
      {
        onError: (err: unknown) => {
          showErrorToast({ error: err });
        },
      },
    );
  }, [siteId, cameraKey, openGateMutation]);

  return (
    <>
      <Pressable onPress={handlePress} disabled={openGateMutation.isPending}>
        <View
          bg="surfaceCard"
          borderRadius={theme.spacing.xl}
          borderWidth={1}
          borderColor="borderCard"
          p="5xl"
          gap="3xl"
        >
          <Text textStyle="sm/semibold" color="textMuted">
            Gate control
          </Text>
          <View
            flexDirection="row"
            alignItems="center"
            justifyContent="space-between"
            height={theme.spacing["12xl"]}
            bg="surfaceCardInner"
            borderRadius={theme.spacing.lg}
            borderWidth={1}
            borderColor="borderCard"
            px="3xl"
            py="lg"
            gap="xl"
          >
            <View flex={1} flexDirection="row" alignItems="center" gap="xl" style={{ minWidth: 0 }}>
              <View
                width={theme.spacing["8xl"]}
                height={theme.spacing["8xl"]}
                alignItems="center"
                justifyContent="center"
              >
                <Icon name="lockOpen" size={24} color={theme.colors.interactive.controls.default_midground} />
              </View>
              <Text textStyle="md/regular" color="text">
                Open Gate
              </Text>
            </View>
          </View>
        </View>
      </Pressable>

      <DialogModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        title="Open Gate"
        style={{ maxWidth: 440 }}
      >
        <Text textStyle="sm/regular" color="textMuted" mb="5xl">
          Are you sure you want to open the gate?
        </Text>
        <View flexDirection="row" gap="xl" justifyContent="flex-end">
          <Button label="Cancel" onPress={() => setModalVisible(false)} variant="secondary" variantColor="grey" />
          <Button label="Open Gate" onPress={handleConfirm} variant="primary" variantColor="blue" />
        </View>
      </DialogModal>
    </>
  );
}
